import 'react-datepicker/dist/react-datepicker.css'
import React from 'react'
import { PayoutCurrency } from '../../types/Payout'
import useLocale from '../../hooks/useLocale'
import { formatCurrency } from '../../lib/utils/formatNumber'

interface DisplayPayoutRevenuesProps {
  revenues: number
  currency: PayoutCurrency
  digitAfterDecimalPoint: number
  decimals: number
}

const DisplayPayoutRevenues = ({
  revenues,
  currency,
  digitAfterDecimalPoint,
  decimals,
}: DisplayPayoutRevenuesProps) => {
  const { locale } = useLocale()

  let formattedRevenues: string = formatCurrency(
    revenues,
    digitAfterDecimalPoint,
    decimals,
    currency,
    locale,
  )

  return <>{formattedRevenues}</>
}

export default DisplayPayoutRevenues
